import api from 'Application/api/api';

const getInvestors = (signal, configuration, filters = {}, searchQuery) => {
	const { sortBy = 'createdAt', sortDirection = 'DESC' } = configuration;

	const params = {
		...filters,
		...configuration,
		query: searchQuery,
	};

	if (sortBy && sortDirection) {
		params.sort = `${sortBy},${sortDirection}`;
	}

	return api.get('/investors', {
		params,
		signal,
		timeout: 100000,
	});
};

export default getInvestors;
